import PropTypes from 'prop-types'

import { Text } from 'src/Components'

const Stat = ({ value, label }) => (
  <div>
    <Text element='span' size='s' variant='neutralCool' variantCount='700'>
      {value}
    </Text>
    <Text
      element='span'
      size='xs'
      variant='neutralCool'
      variantCount='800'
      weight='semibold'
    >
      {' '}
      {label}
    </Text>
  </div>
)

Stat.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
}

export default Stat
